<template>
    <div class="request-book-box" flex="cross:center main:center" @click="close">
        <div class="request-box" @click.stop="">
            <div class="close f0" @click="close">
                <img src="@/assets/image2/close.png" />
            </div>
            <div class="title">{{$lang.get().requestForBooksAndMagazines}}</div>
            <div class="intro">{{$lang.get().bookRequestIntro}}</div>
            <div class="line"></div>
            <div class="form-item" flex="cross:center">
                <span>*</span>
                <div class="name">{{$lang.get().inputName}}</div>
                <input v-model="form.name"/>
            </div>
            <div class="form-item" flex="cross:center">
                <span>*</span>
                <div class="name">{{$lang.get().inputAddress}}</div>
                <input v-model="form.address"/>
            </div>
            <div class="form-item" flex="cross:center">
                <span>*</span>
                <div class="name">{{$lang.get().telephone}}</div>
                <input v-model="form.phone"/>
            </div>
            <div class="form-item" flex="cross:center">
                <span></span>
                <div class="name">{{$lang.get().requestFormIntro}}</div>
                <input v-model="form.intro"/>
            </div>
            <div class="btn-0" flex="cross:center main:center" @click="send">{{$lang.get().sendBtn}}</div>
            <div class="btn-1" @click="close" flex="cross:center main:center">{{$lang.get().return}}</div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        book: {
            type: Object,
            default: null
        }
    },
    data(){
        return {
            form: {
                year: '',
                name: '',
                address: '',
                phone: '',
                intro: ''
            }
        }
    },
    methods: {
        close(){
            this.$parent.requestBookDialog = false
        },
        async send(){
            if(!this.form.name){
                return this.$layer.msg(`${this.$lang.get().inputName}${this.$lang.get().msgRequired}`)
            }
            if(!this.form.address){
                return this.$layer.msg(`${this.$lang.get().inputName}${this.$lang.get().msgRequired}`)
            }
            if(!this.form.phone){
                return this.$layer.msg(`${this.$lang.get().telephone}${this.$lang.get().msgRequired}`)
            }
            let index = this.$layer.loading()
            let res = await this.$api.rApi('journal/form/create', {
                year: this.book ? this.book.year : '',
                name: this.form.name,
                address: this.form.address,
                phone: this.form.phone,
                intro: this.form.intro
            })
            this.$layer.close(index)
            if(res.status == 1){
                this.$layer.msg(this.$lang.get().sendSuccess)
                this.close()
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    .request-book-box{
        position: fixed;
        z-index: 99;
        left: 0;
        top: 0;
        width: 100%;
        height: 100vh;
        background: rgba(#000, 0.5);
        .request-box{
            width: 480px;
            height: 695px;
            background: #FFFFFF;
            box-shadow: 0px 10px 20px 1px rgba(0,0,0,0.05);
            border-radius: 10px 10px 10px 10px;
            position: relative;
            .close{
                position: absolute;
                width: 19px;
                height: 19px;
                right: 18px;
                top: 18px;
                cursor: pointer;
                img{
                    width: 19px;
                    height: 19px;
                }
            }
            .title{
                padding-top: 53px;
                padding-left: 35px;
                font-family: Arial, Arial;
                font-weight: bold;
                font-size: 24px;
                color: #000000;
            }
            .intro{
                padding-left: 35px;
                font-family: Arial, Arial;
                font-weight: 400;
                font-size: 14px;
                color: #979797;
                padding-top: 11px;
            }
            .line{
                width: 406px;
                height: 1px;
                background:#707070;
                opacity: 0.28;
                margin: 35px;
            }
            .form-item{
                width: 408px;
                height: 56px;
                background: #F6F6F6;
                border-radius: 28px 28px 28px 28px;
                margin-left: 35px;
                padding: 0 30px;
                margin-bottom: 30px;
                span{
                    color: red;
                }
                input{
                    flex: 1;
                    height: 56px;
                    border: 0;
                    font-size: 14px;
                    outline: none;
                    background: none;
                    padding-left: 20px;
                }
                .name{
                    white-space: nowrap;
                    font-family: Arial, Arial;
                    font-weight: 400;
                    font-size: 14px;
                    color: #333333;
                }

            }
        }
        .btn-0{
            width: 408px;
            height: 56px;
            background: #006346;
            border-radius: 28px 28px 28px 28px;
            margin: 35px;
            font-family: Arial, Arial;
            font-weight: 400;
            font-size: 14px;
            color: #FFFFFF;
            margin-bottom: 10px;
            cursor: pointer;
        }
        .btn-1{
            width: 408px;
            height: 56px;
            background: #B9B9B9;
            border-radius: 28px 28px 28px 28px;
            margin: 35px;
            margin-top: 10px;
            font-family: Arial, Arial;
            font-weight: 400;
            font-size: 14px;
            color: #FFFFFF;
            cursor: pointer;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/RequestBook.vue